import { IHlsLevel } from './IHlsLevel';
import { IHlsPlayerLevelsUpdatedData } from './IHlsPlayerLevelsUpdatedData';
import { IOnHlsLevelsChangedData, IOnHlsLevelsChangedPlayer } from './IOnHlsLevelsChangedData';

export function buildMainPlayerLevelsChangedData(data: IHlsPlayerLevelsUpdatedData): IOnHlsLevelsChangedData {
	return {
		players: [
			buildLevelsChangedDataForPlayer('Main Player Level', data)
		]
	};
}

export function buildLevelsChangedDataForPlayer(label: string, data: IHlsPlayerLevelsUpdatedData): IOnHlsLevelsChangedPlayer {
	const autoLevelIndex: number = -1;
	const autoLevel: IHlsLevel = {
		index: autoLevelIndex,
		isActive: false,
		isSelected: data.selectedLevelIndex === autoLevelIndex,
		label: 'Auto'
	};
	const playlistLevels: IHlsLevel[] = data.levels
		.map((level, index) => ({
			index,
			isActive: data.activeLevelIndex === index,
			isSelected: data.selectedLevelIndex === index,
			label: '' + level.bitrate
		}));
	const levels = [
		autoLevel,
		...playlistLevels
	];

	return {
		label,
		levels,
		setLevel: data.setLevel
	};
}
